import { ResendFaxArgs, SendFaxArgs } from '@hb/shared'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../../backend/functions/functions'

export const sendFax = httpsCallable<SendFaxArgs>(functions, 'sendFax')
export const resendFax = httpsCallable<ResendFaxArgs>(functions, 'resendFax')
export const testGetFile = httpsCallable(functions, 'testGetFile')
